import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  manager: null,
  defaultFileStatus: null,
  defaultFolders: null,
  availableStatuses: null,
  registryRights: [],
  table: {
    search: "",
    limit: 11,
    page: 1,
    pages: 1,
    sort: "",
    data: [],
    searchFields: [
      {
        key: "[ma].entryName",
        name: "global:device.manufacturer",
      },
      { key: "[pm].modelName", name: "global:device.model" },
      { key: "[sb].entryName", name: "global:device.serviceBase" },
      { key: "serialNumber", name: "global:device.serialNumber" },
      { key: "registrationNumber", name: "global:device.registrationNumber" },
      { key: "[c].name", name: "global:device.client" },
      { key: "[b].name", name: "global:device.branch" },
      { key: "[s].name", name: "global:device.status" },
      { key: "addressFloor", name: "global:device.addressFloor" },
    ],
    selectedSearchFields: [
      "[ma].entryName",
      "[pm].modelName",
      "[sb].entryName",
      "serialNumber",
      "registrationNumber",
      "[c].name",
      "[b].name",
      "[s].name",
      "addressFloor",
    ],
    dictionaryFields: ["serviceBase", "servicePriority", "deviceOwner"],
    url: "device",
  },
};

const deviceReducer = createSlice({
  name: "deviceReducer",
  initialState,
  reducers: {
    setRegistryRights: (state, { payload }) => {
      state.registryRights = payload;
    },
    updateManager: (state, { payload }) => {
      state.manager = payload;
    },
    updateDefaultFileStatus: (state, { payload }) => {
      state.defaultFileStatus = payload;
    },
    updateDefaultFolders: (state, { payload }) => {
      state.defaultFolders = payload;
    },
    updateAvailableStatuses: (state, { payload }) => {
      state.availableStatuses = payload;
    },
    updateRegistry: (state, { payload }) => {
      state.table = { ...state.table, ...payload };
    },
    clearRegistry: () => initialState,
  },
  extraReducers: {},
});

export const {
  updateRegistry,
  clearRegistry,
  updateManager,
  updateDefaultFileStatus,
  updateDefaultFolders,
  updateAvailableStatuses,
  setRegistryRights,
} = deviceReducer.actions;

export default deviceReducer.reducer;
